export const persistKey = (suffix: string) => `GREEN_TECH_${suffix}`;

export const has = (key: string) => !!localStorage.getItem(persistKey(key));

export const writeOnce = (key: string) => localStorage.setItem(persistKey(key), '1');

export const readOnce = (key: string) => {
  const signal = persistKey(key);
  const value = has(signal);
  if (value) {
    return value;
  }

  writeOnce(key);
};
